// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as SavedAddressesActions } from '../../saved-addresses/duck';
import { actions as AlertActions } from '../../../alert/duck';
import SavedAddresses from '../components/SavedAddresses';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    isPostingAddress: state.preferences.savedAddresses.isPostingAddress,
    isPuttingAddress: state.preferences.savedAddresses.isPuttingAddress,
    isDeletingAddress: state.preferences.savedAddresses.isDeletingAddress,
    addresses: state.preferences.savedAddresses.addresses,
    closeAddressModal: state.preferences.savedAddresses.closeAddressModal,
    successDelete: state.preferences.savedAddresses.successDelete,
    postAddressError: state.preferences.savedAddresses.postAddressError,
    putAddressError: state.preferences.savedAddresses.editAddressError,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...SavedAddressesActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SavedAddresses);



// WEBPACK FOOTER //
// ./src/modules/preferences/saved-addresses/containers/SavedAddressesContainer.js